export const CATEGORY = {
  FAIL_FETCH: "CATEGORY_FAIL_FETCH",
  SUCCESS_FETCH: "CATEGORY_SUCCESS_FETCH",
};
